(function () {
  'use strict';

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function qs(root, sel) { return root.querySelector(sel); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function TapSelector(root, opts) {
    this.root = root;
    this.opts = opts || {};
    this.state = {
      waterType: null, series: null,
      committedWaterType: null, committedSeries: null,
      selectedVariant: null, modalCard: null
    };

    // Cache of already-built media DOM nodes, keyed by the option element
    // that produced them, so re-selecting the same option reuses the node
    // instead of rebuilding/reloading it. Also remember whatever was last
    // shown on the stage so the modal can restore it exactly on close.
    this.mediaCache = new WeakMap();
    this.lastBgHtml = null;
    this.lastBgOwner = null;

    this.panelwrap = qs(root, '[data-wts-panelwrap]');
    this.panels = { 1: qs(root, '[data-wts-panel="1"]'), 2: qs(root, '[data-wts-panel="2"]'), 3: qs(root, '[data-wts-panel="3"]') };
    this.stepIndicators = qsa(root, '[data-wts-step-indicator]');
    this.waterButtons = qsa(root, '[data-wts-select-water]');
    this.seriesButtons = qsa(root, '[data-wts-select-series]');
    this.leftCards = qsa(root, '[data-wts-left-card]');
    this.modalCards = qsa(root, '[data-wts-modal-card]');
    this.next1 = qs(root, '[data-wts-next="1"]');
    this.next2 = qs(root, '[data-wts-next="2"]');

    this.bgLayers = { a: qs(root, '[data-wts-bg-layer="a"]'), b: qs(root, '[data-wts-bg-layer="b"]') };
    this.stageInner = qs(root, '[data-wts-stage-inner]');
    this.activeLayerKey = 'a';
    this.heroGold = qs(root, '[data-wts-hero-gold]');
    this.heroWhite = qs(root, '[data-wts-hero-white]');
    this.heroDesc1 = qs(root, '[data-wts-hero-desc1]');
    this.caption = qs(root, '[data-wts-caption]');

    this.transition = qs(root, '[data-wts-transition]');
    this.modalBackdrop = qs(root, '[data-wts-modal-backdrop]');
    this.modal = qs(root, '[data-wts-modal]');
    this.loadbar = qs(root, '[data-wts-loadbar]');
    this.mediaview = qs(root, '[data-wts-mediaview]');
    this.mediaviewInner = qs(root, '[data-wts-mediaview-inner]');

    this.bind();
    this.applyDefaultMedia();
    this.measureHeight();
    this.applyDeepLink();

    var self = this;
    window.addEventListener('resize', debounce(function () { self.measureHeight(); }, 150));
    window.addEventListener('load', function () { self.measureHeight(); });
    window.addEventListener('popstate', function () { self.applyDeepLink(); });

    /* ----------------------------------------------------------------
       Re-measure whenever the page's own layout shifts above the fold,
       not just on window resize.
       measureHeight() sizes this section to fill whatever's left of the
       viewport below whatever sits above it. That only stays accurate if
       nothing above it changes height after the initial measurement. Some
       headers (custom-element / shadow-DOM ones especially) render with a
       provisional height first and correct it to the real value a moment
       later via JS — a gap our one-off DOMContentLoaded/load measurement
       would miss, showing up as a sliver of page scroll. Watching
       document.body's own box size catches that correction (and any other
       later layout shift above the section) generically, without needing
       to know anything about what the header/theme actually is.
    ---------------------------------------------------------------- */
    if (window.ResizeObserver) {
      var remeasure = debounce(function () { self.measureHeight(); }, 60);
      var ro = new ResizeObserver(remeasure);
      ro.observe(document.body);
      // The header publishes its height on <html> and its own bar can settle
      // after fonts/logo load without <body> ever resizing, so watch the
      // header host too when it's present.
      var aliaHost = document.querySelector('alia-header, alia-shell');
      if (aliaHost) ro.observe(aliaHost);
    }
    // Always run a couple of delayed re-checks regardless: they cost nothing
    // and reliably catch an async header-height correction that lands after
    // our initial measurement (the root cause of the mobile scroll gap).
    setTimeout(function () { self.measureHeight(); }, 300);
    setTimeout(function () { self.measureHeight(); }, 1200);
  }

  /* ---- URL deep-linking ---- */
  TapSelector.prototype.applyDeepLink = function () {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return; }
    var raw = params.get('water-type') || params.get('water_type') ||
              params.get('filtered-water-type') || params.get('type');
    if (!raw) return;

    var wanted = this.normaliseWaterType(raw);
    var self = this;
    var btn = this.waterButtons.filter(function (b) {
      return self.normaliseWaterType(b.getAttribute('data-value')) === wanted;
    })[0];
    if (!btn) return;

    this.chooseWaterType(btn);
    this.proceedFromWaterType();

    var style = params.get('style') || params.get('series');
    if (style && this.state.waterType) {
      var sBtn = this.seriesButtons.filter(function (b) {
        return b.getAttribute('data-value').toLowerCase() === style.toLowerCase() &&
               b.getAttribute('data-unavailable') !== 'true';
      })[0];
      if (sBtn) { this.chooseSeries(sBtn); this.proceedFromSeries(); }
    }
  };

  TapSelector.prototype.normaliseWaterType = function (v) {
    if (!v) return '';
    var s = String(v).toLowerCase().replace(/[\s+._-]/g, '');
    var map = {
      b: 'b', boiling: 'b', hot: 'b',
      bc: 'bc', hc: 'bc', boilingchilled: 'bc', hotcold: 'bc', boilingandchilled: 'bc',
      bcs: 'bcs', hcs: 'bcs', boilingchilledsparkling: 'bcs', hotcoldsparkling: 'bcs',
      c: 'c', chilled: 'c', cold: 'c',
      cs: 'cs', chilledsparkling: 'cs',
      s: 's', sparkling: 's'
    };
    if (map[s]) return map[s];
    return s;
  };

  /* ---- loading bar ---- */
  TapSelector.prototype.showLoad = function () { if (this.loadbar) this.loadbar.classList.add('is-on'); };
  TapSelector.prototype.hideLoad = function () { if (this.loadbar) this.loadbar.classList.remove('is-on'); };
  TapSelector.prototype.watchLoad = function (container) {
    var self = this;
    if (!container) return;
    var el = container.querySelector('img, video, iframe, model-viewer');
    if (!el) { this.hideLoad(); return; }
    this.showLoad();
    var done = function () { self.hideLoad(); };
    var tag = el.tagName.toLowerCase();
    if (tag === 'img') {
      if (el.complete) { done(); return; }
      el.addEventListener('load', done, { once: true });
      el.addEventListener('error', done, { once: true });
    } else if (tag === 'video') {
      el.addEventListener('loadeddata', done, { once: true });
      el.addEventListener('error', done, { once: true });
    } else if (tag === 'model-viewer') {
      el.addEventListener('load', done, { once: true });
    } else {
      el.addEventListener('load', done, { once: true });
    }
    setTimeout(done, 6000);
  };

  /* ---- header-aware height ----
     The section fills the viewport below whatever sits above it (the fixed
     site header, an announcement bar, etc). Rather than model exactly what
     sits above the section — which we've learned is fragile, because the
     header reports its height asynchronously and can be off by a few px —
     this now works in two stages:

       1. Set a best-first-estimate height from the header's own live
          variable (or rect.top as a fallback).
       2. On the next frame, measure how much the PAGE can actually still
          scroll (document scrollHeight vs. viewport) and subtract exactly
          that from the section. Whatever the leftover overflow was caused
          by — a stale header height, a wrapper margin, sub-pixel rounding —
          it gets removed directly, because we're measuring the symptom
          (page scroll) rather than guessing at the cause.

     Stage 2 only ever SHRINKS the section to kill scroll; it never grows it,
     so it can't itself create a gap. A tolerance avoids fighting over 1px. */
  TapSelector.prototype.measureHeight = function () {
    var extra = parseInt(this.root.getAttribute('data-extra-offset') || '0', 10);
    var rootStyle = getComputedStyle(document.documentElement);
    var headerVar = (rootStyle.getPropertyValue('--alia-hdr-h') || '').trim();

    // --- Stage 1: best first estimate -------------------------------------
    if (headerVar) {
      var aboveVar = (rootStyle.getPropertyValue('--alia-top') || '0px').trim() || '0px';
      this.root.style.setProperty(
        '--wts-vh',
        'calc(100svh - ' + headerVar + ' - ' + aboveVar + ' - ' + extra + 'px)'
      );
    } else {
      var rect = this.root.getBoundingClientRect();
      var top = Math.max(0, rect.top);
      this.root.style.setProperty('--wts-vh', 'calc(100svh - ' + (top + extra) + 'px)');
    }

    // --- Stage 2: correct against the real remaining page scroll ----------
    this.trimOverflow();
  };

  /* Measure the page's actual residual scroll and pull the page up by
     exactly that amount using a negative bottom margin on the section's
     OUTER wrapper (the theme's #shopify-section-* div, or the section
     itself as a fallback).

     Why the wrapper margin rather than the section's own height: on mobile
     the section is rendered with CSS `zoom`, so a pixel value written into
     its own `height` is interpreted in the section's pre-zoom coordinate
     space and then scaled — measuring the post-zoom rendered overflow and
     writing it back into a zoomed property double-applies the scale. The
     wrapper sits OUTSIDE the zoomed box, so a margin in real screen pixels
     there removes exactly the measured scroll with no scaling to reconcile.
     A negative bottom margin only pulls following content (and the document
     bottom) up; it can't create a gap, so it's safe to over- rather than
     under-correct within the measured overflow. */
  TapSelector.prototype.trimOverflow = function () {
    // Only safe when nothing is rendered below the section to overlap.
    if (!this.opts || !this.opts.trimOverflow) return;
    var self = this;
    if (this._trimRaf) cancelAnimationFrame(this._trimRaf);
    this._trimRaf = requestAnimationFrame(function () {
      self._trimRaf = null;

      var wrapper = self.root.closest('[id^="shopify-section-"]') || self.root;

      // Reset any prior correction first so the measurement is clean.
      var prev = self._trimApplied || 0;
      if (prev) wrapper.style.marginBottom = '';

      // Measure on the next frame after the reset lands.
      requestAnimationFrame(function () {
        var docEl = document.documentElement;
        var viewport = window.innerHeight || docEl.clientHeight;
        var overflow = Math.ceil(
          Math.max(docEl.scrollHeight, document.body ? document.body.scrollHeight : 0) - viewport
        );

        if (overflow <= 1) {
          self._trimApplied = 0;
          return;
        }

        wrapper.style.marginBottom = '-' + overflow + 'px';
        self._trimApplied = overflow;

        // Guard: if scroll somehow remains (rare layout thrash), one more
        // pass usually settles it, but never loop more than twice.
        if (!self._trimSecondPass) {
          self._trimSecondPass = true;
          requestAnimationFrame(function () {
            self._trimSecondPass = false;
            var remain = Math.ceil(
              Math.max(docEl.scrollHeight, document.body ? document.body.scrollHeight : 0) - (window.innerHeight || docEl.clientHeight)
            );
            if (remain > 1) {
              wrapper.style.marginBottom = '-' + (overflow + remain) + 'px';
              self._trimApplied = overflow + remain;
            }
          });
        }
      });
    });
  };

  /* ---- media + hero ---- */
  TapSelector.prototype.isMobile = function () {
    return window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
  };

  TapSelector.prototype.readMediaFrom = function (wrap) {
    if (!wrap) return null;
    var bgTpl = qs(wrap, '[data-wts-bg]');
    var bgMobileTpl = qs(wrap, '[data-wts-bg-mobile]');
    var d1Tpl = qs(wrap, '[data-wts-desc1]');
    var trigger = wrap.matches && wrap.matches('[data-wts-select-water],[data-wts-select-series]') ? wrap : qs(wrap, '[data-wts-select-water],[data-wts-select-series]');
    var goldSrc = trigger || wrap;
    var html = bgTpl ? bgTpl.innerHTML : null;
    if (this.isMobile() && bgMobileTpl && bgMobileTpl.innerHTML.trim()) {
      html = bgMobileTpl.innerHTML;
    }
    return {
      gold: goldSrc.getAttribute ? goldSrc.getAttribute('data-wts-gold') : null,
      white: goldSrc.getAttribute ? goldSrc.getAttribute('data-wts-white') : null,
      desc1: d1Tpl ? d1Tpl.innerHTML : null,
      bgHtml: html
    };
  };

  TapSelector.prototype.applyDefaultMedia = function () {
    var defaults = qs(this.root, '[data-wts-defaults]');
    if (defaults) this.applyMedia(this.readMediaFrom(defaults), defaults);
  };

  TapSelector.prototype.applyMedia = function (media, owner) {
    if (!media) return;
    if (media.bgHtml != null) this.crossfadeBackground(media.bgHtml, owner);
    var self = this;
    if (this.caption) this.caption.style.opacity = '0';
    setTimeout(function () {
      if (media.gold != null && self.heroGold) self.heroGold.textContent = media.gold;
      if (media.white != null && self.heroWhite) self.heroWhite.textContent = media.white;
      if (media.desc1 != null && self.heroDesc1) self.heroDesc1.innerHTML = media.desc1;
      if (self.caption) self.caption.style.opacity = '1';
    }, this.caption ? 160 : 0);
  };

  /* ---- crossfade with per-option media cache ----
     `owner` is the stable DOM element (option card / swatch) this media
     belongs to. If we've built its media node before, we reuse that exact
     node (no rebuild, no reload/redecode) instead of recreating it from
     the HTML string. We also remember the last non-empty html/owner shown,
     so the modal can restore the stage exactly when it closes. */
  TapSelector.prototype.crossfadeBackground = function (html, owner) {
    var nextKey = this.activeLayerKey === 'a' ? 'b' : 'a';
    var nextLayer = this.bgLayers[nextKey];
    var prevLayer = this.bgLayers[this.activeLayerKey];
    if (!nextLayer) return;

    var cachedEl = (html && owner) ? this.mediaCache.get(owner) : null;
    nextLayer.innerHTML = '';

    if (cachedEl) {
      nextLayer.appendChild(cachedEl);
    } else if (html) {
      nextLayer.innerHTML = html;
      if (owner) {
        var builtEl = nextLayer.firstElementChild;
        if (builtEl) this.mediaCache.set(owner, builtEl);
      }
    }

    nextLayer.classList.add('is-active');
    if (prevLayer) prevLayer.classList.remove('is-active');
    this.activeLayerKey = nextKey;

    if (html) {
      if (cachedEl) { this.hideLoad(); } else { this.watchLoad(nextLayer); }
      this.lastBgHtml = html;
      this.lastBgOwner = owner || null;
    } else {
      this.hideLoad();
    }

    setTimeout(function () { if (prevLayer && prevLayer !== nextLayer) prevLayer.innerHTML = ''; }, 550);
  };

  /* ---- transition overlay ---- */
  TapSelector.prototype.withTransition = function (fn) {
    var self = this;
    if (!this.transition) { fn(); return; }
    this.transition.classList.add('is-on');
    setTimeout(function () {
      fn();
      setTimeout(function () { self.transition.classList.remove('is-on'); }, 260);
    }, 380);
  };

  /* ---- panel slide ---- */
  TapSelector.prototype.hidePanel = function () { if (this.panelwrap) this.panelwrap.classList.add('is-hidden'); };
  TapSelector.prototype.showPanel = function () { if (this.panelwrap) this.panelwrap.classList.remove('is-hidden'); };

  /* ---- wiring ---- */
  TapSelector.prototype.bind = function () {
    var self = this;
    this.waterButtons.forEach(function (btn) { btn.addEventListener('click', function () { self.chooseWaterType(btn); }); });
    this.seriesButtons.forEach(function (btn) { btn.addEventListener('click', function () { self.chooseSeries(btn); }); });
    if (this.next1) this.next1.addEventListener('click', function () { self.proceedFromWaterType(); });
    if (this.next2) this.next2.addEventListener('click', function () { self.proceedFromSeries(); });
    qsa(this.root, '[data-wts-back="1"]').forEach(function (b) { b.addEventListener('click', function () { self.goToPanel(1); }); });
    qsa(this.root, '[data-wts-back="2"]').forEach(function (b) { b.addEventListener('click', function () { self.goToPanel(2); }); });
    if (this.modalBackdrop) this.modalBackdrop.addEventListener('click', function () { self.closeModal(); });
    qsa(this.root, '[data-wts-modal-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeModal(); }); });
    qsa(this.root, '[data-wts-expand]').forEach(function (b) { b.addEventListener('click', function () { self.openMediaView(); }); });
    qsa(this.root, '[data-wts-mediaview-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeMediaView(); }); });
    this.leftCards.forEach(function (c) { self.bindLeftCard(c); });
    this.modalCards.forEach(function (c) { self.bindModalCard(c); });
  };

  /* ---- fullscreen media viewer ---- */
  TapSelector.prototype.openMediaView = function () {
    if (!this.mediaview || !this.mediaviewInner) return;
    var active = this.bgLayers[this.activeLayerKey];
    if (!active || !active.innerHTML.trim()) return;
    this.mediaviewInner.innerHTML = active.innerHTML;
    // Fullscreen sizing (mobile only, via CSS) for 3D content instead of
    // the standard 16:9 box, so there's room to orbit the model.
    var is3d = !!qs(this.mediaviewInner, 'model-viewer');
    this.mediaview.classList.toggle('has-3d', is3d);
    this.mediaview.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  TapSelector.prototype.closeMediaView = function () {
    if (!this.mediaview) return;
    this.mediaview.classList.remove('is-open');
    this.mediaview.classList.remove('has-3d');
    if (this.mediaviewInner) this.mediaviewInner.innerHTML = '';
    document.body.style.overflow = '';
  };

  TapSelector.prototype.availableSeriesFor = function (waterType) {
    var set = {};
    this.leftCards.forEach(function (c) { if (c.getAttribute('data-water-type') === waterType) set[c.getAttribute('data-series')] = true; });
    return Object.keys(set);
  };

  /* ---- Step 1 ---- */
  TapSelector.prototype.chooseWaterType = function (btn) {
    this.state.committedWaterType = btn.getAttribute('data-value');
    this.waterButtons.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
    if (this.next1) this.next1.disabled = false;
    var wrap = btn.closest('[data-wts-option-wrap]') || btn;
    this.applyMedia(this.readMediaFrom(wrap), wrap);
  };

  TapSelector.prototype.proceedFromWaterType = function () {
    var self = this;
    var value = this.state.committedWaterType;
    if (!value) return;
    this.state.waterType = value;
    this.state.series = null; this.state.selectedVariant = null;

    var available = this.availableSeriesFor(value);
    this.seriesButtons.forEach(function (btn) {
      var v = btn.getAttribute('data-value');
      btn.setAttribute('data-unavailable', (available.indexOf(v) === -1).toString());
      btn.classList.remove('is-selected');
    });
    this.state.committedSeries = null;
    if (this.next2) this.next2.disabled = true;

    this.setStep(1, 'done'); this.setStep(2, 'active'); this.setStep(3, null); this.setStep(4, null);

    if (available.length <= 1) {
      var only = available[0];
      if (!only) return;
      this.state.committedSeries = only;
      var onlyBtn = this.seriesButtons.filter(function (b) { return b.getAttribute('data-value') === only; })[0];
      if (onlyBtn) {
        var onlyWrap = onlyBtn.closest('[data-wts-option-wrap]') || onlyBtn;
        this.applyMedia(this.readMediaFrom(onlyWrap), onlyWrap);
      }
      this.withTransition(function () { self.proceedFromSeries(); });
    } else {
      this.withTransition(function () { self.goToPanel(2); });
    }
  };

  /* ---- Step 2 ---- */
  TapSelector.prototype.chooseSeries = function (btn) {
    if (btn.getAttribute('data-unavailable') === 'true') return;
    this.state.committedSeries = btn.getAttribute('data-value');
    this.seriesButtons.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
    if (this.next2) this.next2.disabled = false;
    var wrap = btn.closest('[data-wts-option-wrap]') || btn;
    this.applyMedia(this.readMediaFrom(wrap), wrap);
  };

  TapSelector.prototype.setStageSquare = function (square) {
    if (this.stageInner) this.stageInner.classList.toggle('is-square', !!square);
  };

  TapSelector.prototype.proceedFromSeries = function () {
    var self = this;
    var value = this.state.committedSeries;
    if (!value) return;
    this.state.series = value; this.state.selectedVariant = null;

    var matched = null;
    this.leftCards.forEach(function (c) {
      var isMatch = c.getAttribute('data-water-type') === self.state.waterType && c.getAttribute('data-series') === value;
      c.hidden = !isMatch;
      if (isMatch) matched = c;
    });

    this.setStep(2, 'done'); this.setStep(3, 'active');

    var finishCount = matched ? qsa(matched, '[data-wts-swatch]').length : 0;
    if (finishCount <= 1) {
      this.withTransition(function () { self.openModal(); });
    } else {
      this.setStageSquare(true);
      this.withTransition(function () { self.goToPanel(3); });
    }
  };

  TapSelector.prototype.setStep = function (n, status) {
    var el = this.stepIndicators.filter(function (i) { return i.getAttribute('data-wts-step-indicator') === String(n); })[0];
    if (!el) return;
    el.classList.remove('is-active', 'is-done');
    if (status) el.classList.add('is-' + status);
  };

  /* ---- panel navigation: re-shows the current selection's media so
     stepping back never leaves a blank/stale stage ---- */
  TapSelector.prototype.goToPanel = function (n) {
    var self = this;
    this.panels[1].hidden = n !== 1;
    this.panels[2].hidden = n !== 2;
    this.panels[3].hidden = n !== 3;
    this.showPanel();
    if (n === 1) { this.setStep(2, null); this.setStep(3, null); }
    if (n === 1 || n === 2) this.setStageSquare(false);
    else if (n === 3) this.setStageSquare(true);

    if (n === 1 && this.state.committedWaterType) {
      var wBtn = this.waterButtons.filter(function (b) { return b.getAttribute('data-value') === self.state.committedWaterType; })[0];
      if (wBtn) {
        var wWrap = wBtn.closest('[data-wts-option-wrap]') || wBtn;
        this.applyMedia(this.readMediaFrom(wWrap), wWrap);
      }
    } else if (n === 2 && this.state.committedSeries) {
      var sBtn = this.seriesButtons.filter(function (b) { return b.getAttribute('data-value') === self.state.committedSeries; })[0];
      if (sBtn) {
        var sWrap = sBtn.closest('[data-wts-option-wrap]') || sBtn;
        this.applyMedia(this.readMediaFrom(sWrap), sWrap);
      }
    }
  };

  /* ---- Step 3 finish picker ---- */
  TapSelector.prototype.bindLeftCard = function (card) {
    var self = this;
    var swatches = qsa(card, '[data-wts-swatch]');
    var continueBtn = qs(card, '[data-wts-continue]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.getAttribute('data-available') === 'false') return;
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        self.state.selectedVariant = {
          id: swatch.getAttribute('data-variant-id'), price: swatch.getAttribute('data-price'),
          image: swatch.getAttribute('data-image'), title: swatch.getAttribute('data-title'),
          available: swatch.getAttribute('data-available') === 'true'
        };
        qsa(card, '[data-wts-price]').forEach(function (el) { el.textContent = self.formatMoney(self.state.selectedVariant.price); });
        qsa(card, '[data-wts-continue-finish]').forEach(function (el) { el.textContent = self.state.selectedVariant.title; });
        // Live-preview the chosen finish, cached per swatch so flipping
        // between finishes you've already viewed is instant.
        var img = self.state.selectedVariant.image;
        if (img) self.crossfadeBackground('<img src="' + img + '" alt="">', swatch);
      });
    });
    if (continueBtn) continueBtn.addEventListener('click', function () { self.withTransition(function () { self.openModal(); }); });
  };

  /* ---- Step 4 modal ---- */
  TapSelector.prototype.openModal = function () {
    var self = this;
    var matched = this.modalCards.filter(function (c) {
      return c.getAttribute('data-water-type') === self.state.waterType && c.getAttribute('data-series') === self.state.series;
    })[0];
    this.modalCards.forEach(function (c) { c.hidden = c !== matched; });
    this.state.modalCard = matched || null;
    if (!matched) return;

    if (this.state.selectedVariant) this.applyVariantToModal(matched, this.state.selectedVariant);

    this.setStep(3, 'done'); this.setStep(4, 'active');

    this.hidePanel();
    // Blank the stage behind the modal without losing the memory of what
    // was there — crossfadeBackground only updates lastBgHtml/lastBgOwner
    // when html is truthy, so this clear doesn't overwrite it.
    this.crossfadeBackground('');

    if (!this._modalHome && this.modal) {
      this._modalHome = this.modal.parentNode;
      this._modalHomeNext = this.modal.nextSibling;
    }
    if (this.modalBackdrop && this.modalBackdrop.parentNode !== document.body) {
      document.body.appendChild(this.modalBackdrop);
    }
    if (this.modal && this.modal.parentNode !== document.body) {
      document.body.appendChild(this.modal);
    }
    if (this.modal) {
      var cs = getComputedStyle(this.root);
      ['--wts-accent', '--wts-sale'].forEach(function (name) {
        var v = cs.getPropertyValue(name);
        if (v && v.trim()) self.modal.style.setProperty(name, v.trim());
      });
    }
    document.body.classList.add('wts-modal-open');

    if (this.modalBackdrop) this.modalBackdrop.hidden = false;
    if (this.modal) this.modal.hidden = false;
    requestAnimationFrame(function () {
      if (self.modalBackdrop) self.modalBackdrop.classList.add('is-open');
      if (self.modal) self.modal.classList.add('is-open');
    });
  };

  TapSelector.prototype.applyVariantToModal = function (card, v) {
    var self = this;
    qsa(card, '[data-wts-main-image]').forEach(function (img) {
      if (!v.image) return;
      img.style.transition = 'opacity .18s ease';
      img.style.opacity = '0';
      setTimeout(function () { img.src = v.image; img.style.opacity = '1'; }, 160);
    });
    qsa(card, '[data-wts-price]').forEach(function (el) { el.textContent = self.formatMoney(v.price); });
    qsa(card, '[data-wts-dot-current]').forEach(function (el) { el.textContent = v.title; });
    qsa(card, '[data-wts-dot-btn]').forEach(function (b) { b.classList.toggle('is-selected', b.getAttribute('data-variant-id') === v.id); });
    var addBtn = qs(card, '[data-wts-add-to-cart]'), buyBtn = qs(card, '[data-wts-buy-now]'), addLabel = qs(card, '[data-wts-add-label]');
    if (addBtn) { addBtn.setAttribute('data-variant-id', v.id); addBtn.disabled = !v.available; }
    if (buyBtn) { buyBtn.setAttribute('data-variant-id', v.id); buyBtn.disabled = !v.available; }
    if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
  };

  TapSelector.prototype.closeModal = function () {
    var self = this;
    if (this.modalBackdrop) this.modalBackdrop.classList.remove('is-open');
    if (this.modal) this.modal.classList.remove('is-open');
    this.setStep(4, null); this.setStep(3, 'active');
    this.showPanel();
    // Restore exactly what was on the stage before the modal opened —
    // cached, so it reappears instantly instead of reloading.
    if (this.lastBgHtml) this.crossfadeBackground(this.lastBgHtml, this.lastBgOwner);
    document.body.classList.remove('wts-modal-open');
    setTimeout(function () {
      if (self.modalBackdrop) self.modalBackdrop.hidden = true;
      if (self.modal) self.modal.hidden = true;
      if (self._modalHome) {
        if (self.modalBackdrop) self._modalHome.insertBefore(self.modalBackdrop, self._modalHomeNext || null);
        if (self.modal) self._modalHome.insertBefore(self.modal, self._modalHomeNext || null);
      }
    }, 340);
  };

  TapSelector.prototype.bindModalCard = function (card) {
    var self = this;
    var addBtn = qs(card, '[data-wts-add-to-cart]'), buyBtn = qs(card, '[data-wts-buy-now]');
    var addLabel = qs(card, '[data-wts-add-label]'), addMsg = qs(card, '[data-wts-add-msg]');
    var qtyInput = qs(card, '[data-wts-qty-input]'), qtyMinus = qs(card, '[data-wts-qty-minus]'), qtyPlus = qs(card, '[data-wts-qty-plus]');
    var detail = qs(card, '[data-wts-detail]');

    qsa(card, '[data-wts-dot-btn]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (dot.getAttribute('data-available') === 'false') return;
        var v = {
          id: dot.getAttribute('data-variant-id'), price: dot.getAttribute('data-price'),
          image: dot.getAttribute('data-image'), title: dot.getAttribute('data-title'),
          available: dot.getAttribute('data-available') === 'true'
        };
        self.state.selectedVariant = v;
        self.applyVariantToModal(card, v);
      });
    });

    qsa(card, '[data-wts-detail-open]').forEach(function (b) { b.addEventListener('click', function () { if (detail) detail.classList.add('is-open'); }); });
    qsa(card, '[data-wts-detail-close]').forEach(function (b) { b.addEventListener('click', function () { if (detail) detail.classList.remove('is-open'); }); });

    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    if (addBtn) addBtn.addEventListener('click', function () { self.addToCart(addBtn, qtyInput, addMsg, addLabel, false); });
    if (buyBtn) buyBtn.addEventListener('click', function () { self.addToCart(buyBtn, qtyInput, addMsg, addLabel, true); });
  };

  TapSelector.prototype.formatMoney = function (cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, Shopify.money_format) : '$' + (parseInt(cents, 10) / 100).toFixed(2);
  };

  TapSelector.prototype.addToCart = function (btn, qtyInput, msgEl, labelEl, goToCheckout) {
    var variantId = btn.getAttribute('data-variant-id');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (!variantId) return;
    btn.disabled = true;
    var originalLabel = labelEl ? labelEl.textContent : '';
    if (!goToCheckout && labelEl) labelEl.textContent = 'Adding…';
    if (msgEl) { msgEl.textContent = ''; msgEl.className = 'wts__add-msg'; }
    fetch(this.opts.cartAddUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); }); return res.json(); })
      .then(function () {
        if (goToCheckout) { window.location.href = '/checkout'; return; }
        if (labelEl) labelEl.textContent = 'Added ✓';
        if (msgEl) { msgEl.textContent = 'Added to your cart.'; msgEl.className = 'wts__add-msg is-success'; }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { btn.disabled = false; if (labelEl) labelEl.textContent = originalLabel; }, 1800);
      })
      .catch(function (err) {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = originalLabel;
        if (msgEl) { msgEl.textContent = err.message || 'Something went wrong.'; msgEl.className = 'wts__add-msg is-error'; }
      });
  };

  window.WaterTapSelector = { init: function (root, opts) { if (root) new TapSelector(root, opts); } };
})();